import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-progressbar-demo',
  templateUrl: './progressbar-demo.component.html',
  styleUrls: ['./progressbar-demo.component.scss'],
})
export class NgbProgressbarDemoComponent {}
